import type { PropsWithChildren } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { Collection } from "ui/support/Resource";
import type { CsvValue, SetupValueProps } from "../../types";
import { FormField } from "../../../types";

const LayoutCsv = ({
    values,
    onChange,
    children
}: PropsWithChildren<SetupValueProps<CsvValue>>) => {
    const handleDelete = (index?: number) =>
        () => (
            onChange!(
                values[FormField.SetupValue].value
                    .filter((_, i) => i !== index)
            )
        );

    return (
        <Box
            sx={{
                gridColumn: 'span 2'
            }}
        >
            <Collection
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    mb: 2
                }}
                collection={values[FormField.SetupValue].value}
                renderResource={(setupValue, index) => (
                    <Chip
                        key={index}
                        size='small'
                        color='primary'
                        label={setupValue}
                        onDelete={handleDelete(index)}
                    />
                )}
            />
            {children}
        </Box>
    );
};

export default LayoutCsv;
